﻿import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ParticipantDetailsComponent } from './participant-details/participant-details.component';
import { PhoneVerificationComponent } from './phone-verification/phone-verification.component';
import { SurveysService } from '../surveys.service';
import { SurveyDetailsComponent } from './survey-details/survey-details.component';

const routes: Routes = [
    {
        path: 'phone-verification/:id', component: PhoneVerificationComponent
    },
    {
        path: 'survey-details/:id/:prevUrlID/:preview', component: SurveyDetailsComponent
    },
    {
        path: 'survey-details/:id', component: SurveyDetailsComponent
    },
    {
        path: 'participant-details/:id', component: ParticipantDetailsComponent
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    providers: [SurveysService]
})
export class FillSurveysRoutingModule { }